module.exports = __webpack_public_path__ + "static/media/Image 8.45db17cb.jpg";